import React, { useState, useEffect } from 'react';
import { getDonationStatement } from '../../service/SpatApi';
import { queryCategoryConfig } from '../../service/UtilApi';
import { convertTimestampToDate, areDatesEqual, formatINR, getAddressAreadSubAreadDetailsTamil } from "../../utils/Utilities";
import '../general/General.css';
import { Loading } from '../../components/shared';
import { useRef } from 'react';
import { printHtmlContent } from "../../utils/printTemplate";
import { useSelector } from "react-redux";
const DonationStatement = () => {
  const [filters, setFilters] = useState({
    familyId: '',
    from: '',
    to: '',
    categoryDescription: '',
    subCategoryDescription: ''
  });
  const user = useSelector((state) => state.user);
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [categoriesError, setCategoriesError] = useState('');

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const tableRef = useRef(null);

  const handlePrint = () => {
    if (!tableRef.current) return;

    printHtmlContent(tableRef.current.innerHTML, {
      title: 'நன்கொடை அறிக்கை',
      header: 'நன்கொடை அறிக்கை',
      footer: '',
      statementTitle:
        `${filters.categoryDescription} - ${filters.subCategoryDescription}`
    });
  };

  // Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      setLoadingCategories(true);
      try {
        const response = await queryCategoryConfig();
        if (response?.categoriesList?.length) {
          setCategories(response.categoriesList);
        } else {
          setCategoriesError('வகைகள் ஏதும் இல்லை');
        }
      } catch (err) {
        setCategoriesError('வகைகளை ஏற்ற முடியவில்லை');
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // Handle change for filters (date/category/subcategory/familyId)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'categoryDescription' && { subCategoryDescription: '' }),
    }));
  };

  // Get subcategories for selected category
  const selectedCategory = categories.find(cat => cat.categoryName === filters.categoryDescription);
  const subcategories = selectedCategory?.subcategories || [];

  // Fetch donations
  const fetchData = async () => {
    const { from, to, categoryDescription, subCategoryDescription, familyId } = filters;

    if (!categoryDescription) {
      setError('தயவுசெய்து ஒரு வகையைத் தேர்ந்தெடுக்கவும்.');
      return;
    }

    if (!subCategoryDescription) {
      setError('தயவுசெய்து ஒரு துணைவகையைத் தேர்ந்தெடுக்கவும்.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const queryParams = {
        category: categoryDescription,
        subcategory: subCategoryDescription,
        ...(from && { from }),
        ...(to && { to }),
        ...(familyId && { familyId }),
      };

      const resp = await getDonationStatement(queryParams);

      const sortedTransactions = (resp.transactions || []).sort((a, b) => {
        // 1️⃣ Sort by transactionDate (ascending)
        const dateA = a.transactionDate?.toDate
          ? a.transactionDate.toDate()
          : new Date(a.transactionDate._seconds * 1000);

        const dateB = b.transactionDate?.toDate
          ? b.transactionDate.toDate()
          : new Date(b.transactionDate._seconds * 1000);

        const dateDiff = dateA.getTime() - dateB.getTime();
        if (dateDiff !== 0) {
          return dateDiff;
        }

        // 2️⃣ If same date, sort by receipt number
        const rA = Number(a.receiptNo || a.onlineReceiptNo || 0);
        const rB = Number(b.receiptNo || b.onlineReceiptNo || 0);

        return rA - rB;
      });

      for (const d of sortedTransactions) {
        if (d.permanentAddressAreaId && d.permanentSubareaId) {
          d.permanentAddress =
            await getAddressAreadSubAreadDetailsTamil(
              d.permanentAddressAreaId,
              d.permanentSubareaId
            );
        }

        if (d.tempAddressAreaId && d.tempSubareaId) {
          d.tempAddress =
            await getAddressAreadSubAreadDetailsTamil(
              d.tempAddressAreaId,
              d.tempSubareaId
            );
        }
      }



      setTransactions(sortedTransactions);
    } catch (err) {
      console.error(err);
      setError('Failed to load category statement');
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <h2>நன்கொடை விவரங்கள் </h2>

      <div className="auth_element">
        <label className="auth_label">
          வகை:
          {loadingCategories ? (
            <Loading />
          ) : categoriesError ? (
            <p style={{ color: 'red' }}>{categoriesError}</p>
          ) : (
            <select
              className="auth_input"
              name="categoryDescription"
              value={filters.categoryDescription}
              onChange={handleChange}
            >
              <option value="">-- வகையை தேர்ந்தெடுக்கவும் --</option>
              {categories.map(cat => (
                <option key={cat.categoryName} value={cat.categoryName}>
                  {cat.description}
                </option>
              ))}
            </select>
          )}
        </label>

        <label className="auth_label">
          துணைவகை:
          <select
            className="auth_input"
            name="subCategoryDescription"
            value={filters.subCategoryDescription}
            onChange={handleChange}
            disabled={!filters.categoryDescription}
          >
            <option value="">-- துணைவகையை தேர்ந்தெடுக்கவும் --</option>
            {subcategories.map(sub => (
              <option key={sub.name} value={sub.name}>
                {sub.description || sub.name}
              </option>
            ))}
          </select>
        </label>
        <br />

        <h4>தேதி வரம்பு அல்லது குடும்ப எண் தேவை </h4>
        <br />
        <label className="auth_label">
          தேதி முதல்:
          <input
            className="auth_input"
            name="from"
            type="date"
            onChange={handleChange}
            value={filters.from}
          />
        </label>

        <label className="auth_label">
          தேதி வரை:
          <input
            className="auth_input"
            name="to"
            type="date"
            onChange={handleChange}
            value={filters.to}
          />
        </label>

        <label className="auth_label">
          குடும்ப எண்:
          <input
            className="auth_input"
            name="familyId"
            value={filters.familyId}
            onChange={handleChange}
            placeholder="குடும்ப எண்"
          />
        </label>



        <button className="auth_button" onClick={fetchData} disabled={loading}>
          {loading ? 'ஏற்றுகிறது...' : 'அறிக்கையை பெறவும்'}
        </button>

        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div >

      {transactions.length > 0 ? (
        <>
          {user?.roles?.includes('SuperUser') && (
            <button onClick={handlePrint} style={{ margin: '1rem 0' }}>
              🖨️  அச்சிடு
            </button>
          )}
          <div className="table-container" ref={tableRef}>
            <table className="table">
              <thead>
                <tr>
                  <th >தேதி</th> {/* Effective Date */}
                  <th >குடும்ப எண்</th>
                  <th >ரசீது எண்</th>
                  <th>விளக்கம்</th>     {/* Subcategory + optional Transaction Date */}
                  <th >தொகை</th>        {/* Amount */}
                </tr>
              </thead>
              <tbody>
                {transactions.map((d, idx) => {
                  const transactionDate = convertTimestampToDate(d.transactionDate);
                  const effectiveDate = convertTimestampToDate(d.effectiveDate);
                  const datesDiffer = !areDatesEqual(transactionDate, effectiveDate);

                  return (
                    <tr key={idx}>
                      <td style={{ whiteSpace: 'nowrap' }}>{transactionDate.toLocaleDateString()}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{d.familyId}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{d.receiptNo || ''}</td>

                      <td>
                        {(d.familyMemberFirstName) && (
                          <>
                            {d.familyMemberFirstName && <>  {' பெயர்: ' + d.familyMemberFirstName}</>} {d.familyMemberLastName && <>  {' ' + d.familyMemberLastName}</>}
                          </>
                        )}
                        {datesDiffer && (
                          <> (கணக்கு தேதி: {effectiveDate.toLocaleDateString()})</>
                        )}
                        {d.externalTransactionReference && (
                          <> குறிப்பு:{d.externalTransactionReference}</>
                        )}
                        {d.transactionMode === 'UPI' && (
                          <> முறை:{d.transactionMode}</>
                        )}
                        {d.permanentAddress && (
                          <div>
                            (நி):
                            {Array.from(new Set([
                              d.permanentAddress.subarea_tamil,
                              d.permanentAddress.area_tamil,
                              d.permanentAddress.block_tamil,
                              d.permanentAddress.district_tamil,
                            ].filter(Boolean))).join(', ')}
                          </div>
                        )}

                        {d.tempAddress && (
                          <div>
                            (த):
                            {Array.from(new Set([
                              d.tempAddress.subarea_tamil,
                              d.tempAddress.area_tamil,
                              d.tempAddress.block_tamil,
                              d.tempAddress.district_tamil,
                            ].filter(Boolean))).join(', ')}
                          </div>
                        )}
                        {d.totalTillDate != null && (
                          <div style={{ fontSize: '0.85em', color: '#555' }}>
                            இதுவரை: {formatINR(d.totalTillDate)}
                          </div>
                        )}



                      </td>
                      <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        {formatINR(d.amount)}

                      </td>

                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    மொத்தம்:
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {formatINR(transactions.reduce((sum, d) => sum + (d.amount || 0), 0))}
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </>
      ) : (
        !loading && <p>பதிவுகள் ஏதுமில்லை.</p>
      )}
    </>
  );
};

export default DonationStatement;